// extracted by mini-css-extract-plugin
module.exports = {"component":"sidebar-component--tXN5s"};